import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import {
  weightFairyweightAPI,
  weightPlasticAntweightAPI,
  weightAntweightAPI,
  weightBeetleweightAPI,
  weightHobbyweightAPI,
  weightFeatherweightAPI,
  weightSportsmanAPI,
} from "../../routes/apiEndPoints";

export const transformLessonData = (data) => {
  return data?.length > 0
    ? data.map((item) => ({
        ...item,
        title: item?.weight_class_title ?? "",
        text: item?.weight_class_description ?? "",
        image: item?.weight_class_image ?? "",
      }))
    : [];
};

//"fetch-weight-fairyweight"
export const fetchFairyweight = createAsyncThunk(
  "fetch-weight-fairyweight",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightFairyweightAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

//"fetch-weight-plastic-antweight"
export const fetchPlasticAntweight = createAsyncThunk(
  "fetch-weight-plastic-antweight",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightPlasticAntweightAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// "fetch-weight-antweight"
export const fetchAntweight = createAsyncThunk(
  "fetch-weight-antweight",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightAntweightAPI,
        method: "GET",
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
);

// "fetch-weight-beetleweight"
export const fetchBeetleweight = createAsyncThunk(
  "fetch-weight-beetleweight",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightBeetleweightAPI,
        method: "GET",
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
);

// "fetch-weight-hobbyweight"
export const fetchHobbyweight = createAsyncThunk(
  "fetch-weight-hobbyweight",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightHobbyweightAPI,
        method: "GET",
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
);

// "fetch-weight-featherweight"
export const fetchFeatherweight = createAsyncThunk(
  "fetch-weight-featherweight",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightFeatherweightAPI,
        method: "GET",
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
);

// "fetch-weight-sportsman"
export const fetchSportsman = createAsyncThunk(
  "fetch-weight-sportsman",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightSportsmanAPI,
        method: "GET",
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }
);
